exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader{position:fixed;top:15px;left:50%;z-index:1000}@media (min-width:992px){.loader{top:58px}}.loader .loader--inner{display:inline-block;position:relative;left:-50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/components/loader/loader.styl
// module id = 772
// module chunks = 0